import DebugModule from './DebugModule'
export default DebugModule
